import { CiCalendarDate } from "react-icons/ci";
import { Button } from "@/components/ui/button/button";
import { Link } from "react-router-dom";

export const HomeAttendanceCard = () => {
  return (
    <div className="w-60 h-24 rounded-md bg-card flex flex-col gap-1 shadow-sm border p-4">
      <div className="flex flex-row items-center pb-2 justify-between">
        <h2 className="text-sm font-medium">My Attendance</h2>

        <CiCalendarDate className="w-4 h-4" />
      </div>
      <div className="pt-2">
        <Button variant="default" asChild size="sm">
          <Link to="/employee/profile/attendance">View</Link>
        </Button>
      </div>
    </div>
  );
};
